// here you could add the page aliases that will be use in you app
// this enum is used in the umbraco and fallBack translations
enum PageKey {
  MyAccount = "myAccount",
  AgentQuickSearch = "agentQuickSearch",
  AccountSettings = "accountSettings",
}

export default PageKey;
